var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentUploadActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#B4A085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.41 20.41L27.58 15.58C27.21 15.21 26.7 15 26.17 15H19C17.9 15 17.01 15.9 17.01 17L17 33C17 34.1 17.89 35 18.99 35H31C32.1 35 33 34.1 33 33V21.83C33 21.3 32.79 20.79 32.41 20.41ZM27.8 28H26V31C26 31.55 25.55 32 25 32C24.45 32 24 31.55 24 31V28H22.21C21.76 28 21.54 27.46 21.86 27.15L24.66 24.36C24.86 24.17 25.17 24.17 25.37 24.36L28.16 27.15C28.46 27.46 28.24 28 27.8 28ZM27 22C26.45 22 26 21.55 26 21V16.5L31.5 22H27Z",
    fill: "#B4A085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUploadActiveIcon);
export default __webpack_public_path__ + "static/media/document_upload_active_icon.7b36932eba27803903a2fc8700ff2eeb.svg";
export { ForwardRef as ReactComponent };